import { createNamedActions } from 'utils/namedActionTypesProxy';
import { handleLoanProgramsOptionsDetails } from 'utils/programs';

export const LOAN_PROGRAM_OPTIONS_DETAILS_ACTION_TYPE = createNamedActions(
  'loanProgramOptionsDetails',
  {
    SET_LOAN_PROGRAM_OPTIONS_DETAILS: 'SET_LOAN_PROGRAM_OPTIONS_DETAILS',
    RESET_LOAN_PROGRAM_OPTIONS_DETAILS: 'RESET_LOAN_PROGRAM_OPTIONS_DETAILS',
  },
);

export const setLoanProgramOptionsDetails = loanProgramOptionsDetails => dispatch =>
  dispatch({
    type: LOAN_PROGRAM_OPTIONS_DETAILS_ACTION_TYPE.SET_LOAN_PROGRAM_OPTIONS_DETAILS,
    payload: handleLoanProgramsOptionsDetails(loanProgramOptionsDetails),
  });

export const resetLoanProgramOptionsDetailsAction = () => ({
  type: LOAN_PROGRAM_OPTIONS_DETAILS_ACTION_TYPE.RESET_LOAN_PROGRAM_OPTIONS_DETAILS,
});
